module.exports = __webpack_public_path__ + "img/37107-011.3aaca87b.jpg";